import { useEffect, useState } from "react";
import Steps from "./Steps";
import { userContext } from '../../../context/usercontext';
import { useContext } from 'react';
import { getAllExpertsRequest,getTimeExpert , sendRequest} from "../../../services/kojaServices";
import { downloadUrl } from "../../../confing/confing.js";
import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import Select from 'react-select';
import ExpertTabel from "./ExpertTabel";
import { addNewExpert } from "./ExpertTabel";
import Swal from 'sweetalert2'
import { toast } from "react-hot-toast";
import Header from '../menu/Header';
import Menu from '../menu/Menu';
import { HiOutlineCalendar } from 'react-icons/hi';

const ExpertInfo = () => {

  const {setRequestStep,expertInfo,setExpertInfo,estateInfo,selectedEx,setSelectedExpert,ownerInfo,setFactorInfo} = useContext(userContext)
  const [experts,setExperts] = useState([])
  const [expertTimes,setExpertTimes] = useState([])
  const [desabledTime,setDisabledTime] = useState([])
  const [desabledInput,setDisabledInput]=useState(false)
  const [loading,setLoading]=useState(false)
  const [startDate, setStartDate] = useState(new Date());
  const [emptyHours,setEmptyHours] = useState([])


      const changeType = async(e)=>{
       try{
        let type = e.target.value
        let id = estateInfo.ExZoneId
        setLoading(true)
       const {data} =await getAllExpertsRequest(id,type)
       setLoading(false)
        let arry = []
        data.result.map((i) => {
          let x = {
            value : i.id ,
            label : i.name,
            img : `${ downloadUrl}${i.pic}`
          }
          arry.push(x)
        })
        setExperts(arry)
        let copy = expertInfo
        copy.type = type
        setExpertInfo(copy)
       }catch(err){
        console.log(err)
        setLoading(false)
       }
      }

     const  changeNumber = (e)=>{
      let number = e.target.value
      let copy = expertInfo
      copy.number = number
      setExpertInfo(copy)
      setDisabledInput(true)
     }

     const selectedExpert = async(e) => {
      try{
      let expert = e.value
      let copy = expertInfo
      copy.ExExpertId = expert
      // console.log(copy)
      setExpertInfo(copy)
      const {data} = await getTimeExpert(expert)
      setExpertTimes(data.result)
      DisabledTime(data.result)
      // console.log(data.result)
      }catch(err){
        console.log(err)
      }
     }

     const DisabledTime = (times)=>{
        const arry = []
        times.map((t)=>{
          arry.push(t.date)
        })
        let uniqueArray = Array.from(arry);
        let uniqueSet = new Set(uniqueArray);
        let finalArray = Array.from(uniqueSet);
        // console.log(finalArray)
        setDisabledTime(finalArray)
     }

      const changeDate = (date) => {
        // console.log(date?.format?.("YYYY-MM-DD"))
        let d =date?.format?.("YYYY-MM-DD")
        let copy = expertInfo
        copy.date = d
        let selectDate = new Date(date)
        let arryTimes = []
        expertTimes.map((t)=>{
          let time = new Date(t.date)
          if(time.getFullYear() === selectDate.getFullYear() && time.getMonth() === selectDate.getMonth() && time.getDate() === selectDate.getDate() ){
           arryTimes.push(t)
          }
        })
        setEmptyHours(arryTimes)
        // console.log(arryTimes)
     }

     const selectedTime = (e) =>{
      let scheduleId = Number(e.target.value)
      let time=  e.target.options[e.target.selectedIndex].text
      let copy = expertInfo
      copy.scheduleId = scheduleId
      copy.time = time
     let x = addNewExpert(expertInfo,experts,selectedEx,setExpertInfo)
    //  console.log(x)
      setEmptyHours([])
      setSelectedExpert(x)
      setDisabledTime([])
     }
      
      const nextStep = async(values)=>{
        try{
          const sendData = {
            ...estateInfo,
            selected: "Manual",
            experters : expertInfo.arry,
            owner : ownerInfo
          }
          Swal.fire({
            title: 'لطفا منتظر بمانید',
            didOpen: () => { Swal.showLoading() },
          })       
           const {data} = await sendRequest(sendData)
          console.log(data)
          setFactorInfo(data.result)
          Swal.close()
          Swal.fire({
            icon: 'success',
            title: `درخواست شما با موفقیت ثبت شد`,
            showConfirmButton: false,
            timer: 2000
          })
          setRequestStep(4)
        }catch(err){
          console.log(err)
          Swal.close()
          toast.error("خطایی رخ داده است مجدد تلاش کنید")
        }
        // setRequestStep(4)
    }
    const previousStep = (values)=>{
        setRequestStep(2)
    }

    const customStyles = {
      container : (provided, state) => ({
        ...provided,
        backgroundColor: "#37768F",
        boxShadow: "0px 4px 4px #000000",
        borderRadius: "90px",
        color : "#fff"
      }),
      control : (provided, state) => ({
        ...provided,
        backgroundColor: "#37768F",
        borderRadius: "90px",
        color: "#fff",
        padding: "8px",
        height: "50px",
      }),
      singleValue : (provided, state) => ({
        ...provided,
        color: "#fff",
      }),
     placeholder : (provided, state) => ({
        ...provided,
        color: "#fff",
      }),
      menu : (provided, state) => ({
        ...provided,
        backgroundColor: " rgba(98, 134, 148, 0.7)",
        boxShadow: "0px 4px 4px #000000",
        borderRadius: "20px",
        color: "#fff",
        padding: "8px",
      }),
    };

    return (
      <div className='expertRequest'>
      <Header/>
      <div className='d-flex request-box-content' style={{margin:"20px 30px 0px 30px"}}>
      <Menu/>
      <div className='w-100 m-1'>
      <Steps step={3}/>
      <div className='text-end m-3 m-md-1 mt-md-3'>
      <div className="row align-items-start ">
      <div className="col-md-6">
      <div className="mb-3 col-12 col-xl-8">
      <label className="mb-1 ms-2 d-flex label-form request-form-label" htmlFor="name"> 1- تعداد کارشناس</label>
      <select
      className="w-100 request-form-input"
      onChange={(e)=>{changeNumber(e)}}
      defaultValue={expertInfo.number || ""}
      disabled={desabledInput}
    >
    <option>لطفا یک گزینه انتخاب کنید</option>
    <option value="single">تک کارشناس</option>
    <option value="several">چند کارشناس</option>
    </select>

      </div>
      <div className="mb-3 col-12 col-xl-8">
      <label className="mb-1 ms-2 d-flex label-form request-form-label" htmlFor="name"> 2- نوع کارشناس</label>
      <select
      className="w-100 request-form-input"
      onChange={(e)=>{changeType(e)}}
      defaultValue={expertInfo.type || "" }
      disabled={!desabledInput}
    >
    <option>لطفا یک گزینه انتخاب کنید</option>
    <option value="Local">محلی</option>
    <option value="Formal">رسمی</option>
    </select>
      </div>
      <div className="mb-3 col-12 col-xl-8">
      <div className="d-flex align-items-center">
      <label className="mb-1 ms-2  label-form request-form-label " htmlFor="name">  3- انتخاب کارشناس</label>
      {
        loading && <div className="spinner-border spinner-border-sm " role="status" style={{display:"inline"}}>
        <span className="visually-hidden">Loading...</span>
        </div>
      }
      </div>
      <Select
      placeholder =  "لطفا یک گزینه انتخاب کنید"
      defaultValue={expertInfo.ExExpertId || ""}
      styles={customStyles}
      onChange={(e)=>{selectedExpert(e)}}
      options={experts}
      isDisabled={expertInfo.type ? false : true}
      components={{
        Option: ({ innerProps, label, data }) => (
          <div {...innerProps} className="mb-2" >
            <img className="ms-3" src={data.img} alt={label} width="40" height="40" style={{ marginRight: '5px' , borderRadius:"20px" }} />
            {label}
          </div>
        ),
      }}
    />
   
      </div>
      </div>
      <div className='col-md-6 '>     
      <div className=" mb-3 col-12 col-xl-8 ">
      <label className="mb-1 ms-2 d-flex label-form request-form-label" htmlFor="name"> 4- انتخاب تاریخ کارشناسی: </label>
     <div className="request-form-input">
     <DatePicker
     disabled={expertInfo.ExExpertId ? false : true}
     value={startDate}
     format="YYYY/MM/DD"
     calendar={persian}
     locale={persian_fa}
     onChange={(date) => {changeDate(date)}}
     render={(value, openCalendar) => {
       return (
         <button className="pe-3 btn  text-white" onClick={openCalendar}>
           {value}
           <HiOutlineCalendar style={{marginRight:"25px" ,width:"25px",height:"25px"}}/>
         </button>
       )
     }}
     mapDays={({ date }) => {
       let y = false
       desabledTime.map((t) => {
         let x = new Date(t)
         let d = new Date(date)
         if(x.getFullYear() === d.getFullYear() && x.getMonth() === d.getMonth() && x.getDate() === d.getDate() ){
           // console.log("x" , x.getDate())
           // console.log("d" , d.getDate())
          return y = true
         }
       })

       if(!y)return {
             disabled: true,
             style: { color: "#ccc" ,
            },
             onClick: () => alert("آخر هفته ها غیر فعال هستند")
           }
     }}
   />
     </div>
 
      </div>
      <div className=" mb-3 col-12 col-xl-8">
      <label className="mb-1 ms-2 d-flex label-form request-form-label" htmlFor="name">5- انتخاب زمان: </label>
      <select
      className="w-100 request-form-input"
      onChange={(e)=>{selectedTime(e)}}
    >
    <option>لطفا یک زمان انتخاب کنید</option>
    {
      emptyHours.map((t,index)=> (
        <option key={index} value={t.id}>{t.time}</option>
      ))
    }
    </select>
      </div>
      </div>
      </div>
      <ExpertTabel/>
      <div className='d-flex justify-content-between'>
      <div className=' request-next-btn-box'>
      <button  type='submit' className='btn request-next-btn' onClick={()=>{nextStep()}}>بعدی</button>
      </div>
      <div className=' request-Previous-btn-box '>
      <button className='btn request-Previous-btn ' type='button' onClick={()=>{previousStep()}}>قبلی</button>
      </div>
      </div>
      </div>
       </div>
      </div>
      </div>
    );
};

export default ExpertInfo;